//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'PwrFormGroup',
  inject: ['bus'],
  props: {
    label: {
      type: String,
      default: null,
    },
    description: {
      type: String,
      default: null,
    },
  },
  data: function data() {
    return {
      errors: [],
    };
  },
  computed: {
    hasErrors() {
      return this.errors.length > 0;
    },
  },
  created() {
    this.bus.$on('pwr-form-invalid', this.handleInvalid);
    this.bus.$on('pwr-form-valid', this.handleValid);
  },
  methods: {
    handleInvalid(message) {
      if (!this.hasChild(message.field)) {
        return;
      }

      if (message.errors) {
        this.errors = message.errors;
      }
    },
    handleValid(message) {
      if (!this.hasChild(message)) {
        return;
      }
      this.errors = [];
    },
    hasChild(name, vm = null) {
      const v = vm || this;
      for (let i = 0; i < v.$children.length; i += 1) {
        if (v.$children[i].$options.name === name) {
          return true;
        }
        if (this.hasChild(name, v.$children[i]) === true) {
          return true;
        }
      }
      return false;
    },
  },
};
